import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <div className="text-center space-y-8 px-4">
        {/* 404 heading */}
        <h1 className="text-9xl font-bold text-blue-600">404</h1>

        {/* Message */}
        <div className="space-y-2">
          <h2 className="text-2xl font-semibold text-gray-900">
            Page not found
          </h2>
          <p className="text-gray-600 max-w-md">
            Sorry, we couldn&apos;t find the page you&apos;re looking for. Please check
            the URL or return home.
          </p>
        </div>

        {/* Action button */}
        <button
          onClick={() => navigate("/")}
          className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg 
            hover:bg-blue-700 transition-colors duration-200"
        >
          <Home className="h-5 w-5" />
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
